import styled from '@emotion/styled';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components';
import React, { useEffect } from 'react';
import CenteredModal from '~/App/Modules/Testimonials/Components/CenteredModal';
import { REMOVE_CONTACT } from '~/generated/AnalyticsTypes';
import { assetUrl } from '~/helpers';
import useAnalytics from '~/react-hooks/use-analytics';
import {
  ManageResourceContactParams,
  useUnassignResourceContact,
} from '../Api/ResourceContacts';

const RemoveIcon = styled.div`
  mask-repeat: no-repeat;
  mask-position: center;
  mask-image: url(\'${assetUrl(
    'assets/images/my-library/remove-contact.svg'
  )}\');
`;

export interface RemoveContactModalProps extends ManageResourceContactParams {
  open: boolean;
  onModalClose: () => void;
  onSuccess?: () => void;
}

const RemoveContactModal = ({
  profileUuid,
  resourceType,
  resourceUuid,
  open,
  onModalClose,
  onSuccess,
}: RemoveContactModalProps) => {
  const analytics = useAnalytics();
  const { mutateAsync, isLoading } = useUnassignResourceContact({
    options: {
      onSuccess: () => {
        onModalClose();
        onSuccess?.();
      },
    },
  });

  const handleClose = () => {
    if (!isLoading) {
      onModalClose();
    }
  };

  const handleRemove = () => {
    void mutateAsync({
      profileUuid,
      resourceType,
      resourceUuid,
    });
  };

  useEffect(() => {
    if (open) {
      analytics.track(REMOVE_CONTACT);
    }
  }, [open]);
  return (
    <CenteredModal
      open={open}
      hideCloseButton
      onRequestClose={handleClose}
      width={480}
    >
      <div className='relative'>
        <Button
          className='absolute right-[0] !p-0'
          variant={ButtonVariant.Icon}
          onClick={handleClose}
        >
          <i className='fal fa-times font-bold text-neutral-300 text-3xl' />
        </Button>
        <div className='flex justify-center mb-5'>
          <RemoveIcon className='w-[50px] h-[50px] bg-pink-900' />
        </div>
        <h2 className='mt-0 text-center text-black mb-4'>
          Are you sure you want to remove the attached contact?
        </h2>
        <div className='flex justify-center'>
          <Button
            variant={ButtonVariant.Info}
            className='mr-2'
            onClick={handleClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button onClick={handleRemove} disabled={isLoading}>
            Remove
          </Button>
        </div>
      </div>
    </CenteredModal>
  );
};

export default RemoveContactModal;
